import Cookies from 'js-cookie';
import { getTokenName, getUserIsLoggedIn } from '../utils/globals';
import { getLogoutUrl } from '../utils/routes';
/**
 * # useLogout
 *
 * A hook that provides a function to logout a user.
 *
 * ```typescript
 * const LogoutComponent = () => {
 *   const { isLoggedIn, logout, url } = useLogout();
 *
 *   console.log({ isLoggedIn }); // boolean
 *   console.log({ url }); // string
 *
 *   const onClick = () => {
 *     if (isLoggedIn) {
 *       logout();
 *     }
 *   };
 *
 *   if (!isLoggedIn) {
 *     return null; // not logged in, don't show button
 *   }
 *
 *   return <button onClick={onClick}>Logout</button>;
 * };
 * ```
 */
export function useLogout() {
    const url = getLogoutUrl();
    const logout = () => {
        const tokenName = getTokenName(window.cname, window.subdomain);
        Cookies.remove(tokenName);
        window.location.href = url;
    };
    return {
        url,
        logout,
        isLoggedIn: getUserIsLoggedIn(),
    };
}
//# sourceMappingURL=useLogout.js.map